import { Button, Input, Modal } from "antd";
import { useMemo, useState } from "react";
import AutoSizer from "react-virtualized-auto-sizer";
import { FixedSizeGrid as Grid } from "react-window";
import { Icons } from "../../../../components/common/icon";

const ITEM_HEIGHT = 80;
const COLUMN_COUNT = 6;
const { Search } = Input;

const ModalIcon = (props) => {
  const { isOpen, onCancel, handleSelectIcon } = props;
  //#region state
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedIcon, setSelectedIcon] = useState(null);
  //#endregion state

  const filteredIcons = useMemo(() => {
    const keyword = searchTerm.trim().toLowerCase();
    return keyword === ""
      ? Icons
      : Icons.filter((icon) => icon.toLowerCase().includes(keyword));
  }, [searchTerm]);

  //#region  function
  const Cell = ({ columnIndex, rowIndex, style }) => {
    const index = rowIndex * COLUMN_COUNT + columnIndex;
    const iconClass = filteredIcons[index];
    if (!iconClass) return null;

    const isSelected = selectedIcon === iconClass;

    return (
      <div
        onClick={() => setSelectedIcon(iconClass)}
        style={{
          ...style,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          cursor: "pointer",
          padding: 8,
          border: isSelected ? "2px solid #0070D7" : "2px solid transparent",
          borderRadius: 8,
          backgroundColor: isSelected ? "#F0F6FD" : "transparent",
          transition: "all 0.2s",
        }}
      >
        <i className={iconClass} style={{ fontSize: 24 }} />
        <div
          style={{
            fontSize: 10,
            textAlign: "center",
            marginTop: 4,
            wordBreak: "break-word",
          }}
        >
          {iconClass}
        </div>
      </div>
    );
  };
  const handleSubmit = () => {
    handleSelectIcon(selectedIcon);
    onCancel();
  };
  //#endregion function
  return (
    <Modal
      title="Danh sách icon"
      open={isOpen}
      onCancel={onCancel}
      width="80%"
      footer={
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            {selectedIcon ? (
              <span style={{ marginRight: 16 }}>
                Đã chọn: <b>{selectedIcon}</b>
              </span>
            ) : (
              <span style={{ fontStyle: "italic", color: "#888" }}>
                Chưa chọn icon nào
              </span>
            )}
          </div>
          <div>
            <Button onClick={onCancel}>Đóng</Button>
            <Button onClick={handleSubmit} type="primary">
              Chọn
            </Button>
          </div>
        </div>
      }
    >
      <Search
        placeholder="Tìm theo tên icon (VD: compass, dash, credit...)"
        allowClear
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ marginBottom: 16 }}
      />
      <div style={{ height: 400 }}>
        <AutoSizer>
          {({ width, height }) => {
            const itemWidth = Math.floor(width / COLUMN_COUNT);
            const rowCount = Math.ceil(filteredIcons.length / COLUMN_COUNT);

            return (
              <Grid
                columnCount={COLUMN_COUNT}
                columnWidth={itemWidth}
                height={height}
                rowCount={rowCount}
                rowHeight={ITEM_HEIGHT}
                width={width}
              >
                {Cell}
              </Grid>
            );
          }}
        </AutoSizer>
      </div>
    </Modal>
  );
};

export default ModalIcon;
